import Vue from "vue";

export function deepCopy(target) {
  if (typeof target === "object") {
    const result = Array.isArray(target) ? [] : {};
    for (const key in target) {
      if (target[key] === null) {
        result[key] = target[key];
      } else if (typeof target[key] === "object") {
        result[key] = deepCopy(target[key]);
      } else {
        result[key] = target[key];
      }
    }

    return result;
  }

  return target;
}

export function swap(arr, i, j) {
  const temp = arr[i];
  Vue.set(arr, i, arr[j]);
  Vue.set(arr, j, temp);
}

export function $(selector) {
  return document.querySelector(selector);
}

// 主要用于 Vue 的 diff 算法，为每个元素创建一个独一无二的 ID
export function generateID() {
  return nanoid();
}

function nanoid(num = 8, stamp = true) {
  let data = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z"
  ];
  let nums = "";
  let timestamp = parseInt(new Date().getTime() / 1000) + "";
  for (let i = 0; i < num; i++) {
    let r = parseInt(Math.random() * 61);
    nums += data[r];
  }
  return stamp ? "a" + nums + timestamp : nums;
}

// 判断基本元素类型的数组中是否有重复内容
export function isRepeat(arr) {
  const hash = {};
  for (let i in arr) {
    if (hash[arr[i]]) {
      return true;
    }
    hash[arr[i]] = true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/utils/utils.js